import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";
import { APIConsentService } from '../../_services/consent/API-consent';


const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);

export interface DialogData {
  setValue: string,
  setRole: string
}
@Component({
  selector: 'app-consent-status-summary',
  templateUrl: './consent-status-summary.component.html',
  styleUrls: ['./consent-status-summary.component.css']
})
export class ConsentStatusSummaryComponent implements OnInit {

  maxDate: Date = new Date();
  mindate = new Date(now.getFullYear(), 0, 1);
  maxdate = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  dataSource: MatTableDataSource<any>;
  onSelectdropdown: boolean = true;
  filterData: any;
  fetchedData: any;
  noRecord: any;
  UrnFromURL: any;
  afterApply: boolean = false;
  Entity_ID: any;
  // EntityLegalName: any;
  GstNumber: any;
  pageNo: number = 1;
  pageSize: number = 5;
  length: number = 5;
  Param: any;
  download: boolean = false;
  form1: any = {};
  data: any = {};
  showStatusDropdown: boolean = false

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('tSort') tSort: MatSort;

  dataSubject = new BehaviorSubject<any[]>([]);

  displayedColumns: string[] = ['Consent_ID', 'Consent_Template_ID', 'Entity_ID', 'Msisdn', 'Status', 'Consent_Acq_Date', 'Updated_Time_Stamp'];

  constructor(
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    public dialog: MatDialog,
    private $: $BroadcastManagerService,
    private cst: APIConsentService,
    private router: Router) { }

  ngOnInit() {
    this.Entity_ID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.initialStep();

  }

  initialStep() {
    this.maxDate.setDate(new Date().getDate());
    let data = {
      "filterType": "",
      "param": "",
      "Start_Date": "",
      "End_Date": "",
      "pageNo": this.pageNo,
      "pageSize": '3000',
      "entityID": this.Entity_ID,
      "type": "pageload"
    }
    this.summaryFilter(data)
  }

  onChangeDataSource(value) {
    // console.log("values" + value);
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.tSort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

  searchRequired: boolean = false;
  errorSerch() {
    if (this.form1.searchBy && !this.form1.search) {
      this.searchRequired = true;
    } else {
      this.searchRequired = false;

    }
  }

  openDropdown(value) {
    console.log("value", value)
    if (value == "Status") {
      this.showStatusDropdown = true;
    }
    else {
      this.showStatusDropdown = false;
    }
    console.log("value", value)

  }

  listvalue(event) {
    if (event) {
      this.form1.searchBy = "Status"
    }
  }


  onSubmitFilter(filterForm, form) {

    console.log("filterForm values ---", filterForm);
    console.log("hi !!!");
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.search


    if (typeof param === 'undefined' || param == null)
      param = "";

    console.log("fdate", fdate);
    console.log("ldate", ldate, "param", param);
    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;
    if (filterForm.searchBy1)
      param = filterForm.searchBy1;

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)



    if (fdate != "" && ldate == "") {
      ldate = cdate
    }



    this.data = {

      "filterType": filterType,
      "param": param,
      "Start_Date": fdate,
      "End_Date": ldate,
      "pageNo": this.pageNo,
      "pageSize": "10000",
      "entityID": this.Entity_ID,
      "type": "filter"
    }


    if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }

    else if (fdate != "" && ldate != "" && difference_in_Days > 30) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Date Difference should not be more than 30 days'
      });
    }

    else {
      this.summaryFilter(this.data)
    }
  }

  summaryFilter(data) {

    this.cst.summaryFilter(data)
      .subscribe(r => {
        if (r.status == "success") {
          this.fetchedData = JSON.stringify(r.message);
          this.dataSource = r.message;
          this.onChangeDataSource(r.message);

        } else if (r.status == "fail") {
          this.$modal.errorModal({
            title: 'Consent Status Summary',
            msg: 'Filtered data size is greater, Kindly download the report with releavant filters.'
          });
        } else {
          this.$modal.errorModal({
            title: 'Consent Status Summary',
            msg: r.message
          });
        }
      })
  }


  onOptionsSelected(data) {

    if (data === "CST_Status") {
      this.onSelectdropdown = false;
    } else {
      this.onSelectdropdown = true;
    }
    this.form1.search = "";
  }

  reset() {
    // this.getPECSTReportsAll(this.entityId);
    console.log("first reset function");
    //this.enddateError=false;
    this.initialStep();
    this.onSelectdropdown = true;
    this.searchRequired = false;
    this.afterApply = false;
    this.showStatusDropdown = false;
  }

 isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

  downloadconsentstatussummarycsvfile(filterForm, form) {
    //var data = this.setupFilterCrit(filterForm, form)
    let fdate = ""
    let ldate = ""
    var cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');
    let searchBy = ""
    let search = ""
    if (filterForm.startDate) {
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    }

    if (filterForm.endDate) {
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    } else {
      ldate = cdate
    }

    if (filterForm.searchBy) {
      searchBy = filterForm.searchBy
    }

    if (filterForm.search) {
      search = filterForm.search.trim()
    }

    var filterType, param
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;
    if (filterForm.searchBy1)
      param = filterForm.searchBy1;
    var data = {

      "filterType": filterType,
      "param": param,
      "Start_Date": fdate,
      "End_Date": ldate,
      "pageNo": this.pageNo,
      "pageSize": "",
      "entityID": this.Entity_ID,
      "type": "filter",
      "email": filterForm.email
    }

    if (filterForm.email == undefined || filterForm.email == "") {
      this.$modal.errorModal({
        title: 'Consent Status Summary',
        msg: 'Please enter email id'
      });
    } else if(!this.isValidEmail(filterForm.email)) {
      this.$modal.errorModal({
        title: 'Consent Status Summary',
        msg: 'Please enter Valid email id'
      });
    } else {
      
      this.cst.exportconsentstatussummaryCSV(data).subscribe(r => {
       
        if (r.status == "fail") {
          this.$modal.errorModal({
            title: 'Consent Status Summary',
            msg: r.message
          });
        } else {
          
          this.$modal.successModal({
            title: 'Consent Status Summary',
            msg: r.message
          });
        }
      })
    }

  }

}
